import { createRouter, createWebHistory } from 'vue-router'
import Home from './views/HomePage.vue'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'

// Configuration de nprogress
NProgress.configure({ showSpinner: false, speed: 400, minimum: 0.2 });

const routes = [
  {
    path: '/history',
    name: 'history',
    component: () => import(/* webpackChunkName: "history" */ './views/HistoryPage.vue')
  },
  {
    path: '/cart',
    name: 'cart',
    component: () => import(/* webpackChunkName: "cart" */ './views/CheckoutPage.vue')
  },
  {
    path: '/',
    name: 'home',
    component: Home
  },
  {
    path: '/blog',
    name: 'blog',
    component: () => import(/* webpackChunkName: "blog" */ './views/Blog.vue')
  },
  {
    path: '/produits',
    name: 'catalogue',
    component: () => import(/* webpackChunkName: "catalogue" */ './views/CataloguePage.vue'),
    props: true
  },
  {
    path: '/produits/:id',
    name: 'produits',
    component: () => import(/* webpackChunkName: "produits" */ './views/ProduitsPage.vue'),
    props: true
  },
  {
    path: '/category/:id',
    name: 'category',
    component: () => import(/* webpackChunkName: "category" */ './views/CategoryPage.vue'),
    props: true
  },
  {
    path: '/thenks/:id',
    name: 'thenks',
    component: () => import(/* webpackChunkName: "thenks" */ './views/ThenksPage.vue'),
    props: true
  },
  {
    path: '/fail/:id',
    name: 'fail',
    component: () => import(/* webpackChunkName: "fail" */ './views/FailPage.vue'),
    props: true
  },
  {
    path: '/reset-password',
    name: 'reset-password',
    component: () => import(/* webpackChunkName: "reset-password" */ './views/ResetPassword.vue'),
    props: true
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { top: 0, behavior: 'smooth' };
    }
  }
})

router.beforeEach((to, from, next) => {
  if (to.path !== from.path) {
    NProgress.start();
  }
  next();
});

router.afterEach(() => {
  NProgress.done();
});

export default router
